import { Typography } from '@mui/material'
import { LineSeries, ResponsiveLine } from '@nivo/line'

interface Props {
  dataPoints: LineSeries[]
  height?: number
  title?: string
  labels: { x: string; y: string }
  yFormat?: (e: number) => string
}

export const AreaTimeChart = ({ title, height = 300, dataPoints, labels, yFormat = undefined }: Props) => {
  return (
    <section>
      {title && (
        <Typography variant="h6" component="h2" align="center">
          {title}
        </Typography>
      )}

      <div style={{ height }}>
        <ResponsiveLine
          data={dataPoints}
          margin={{ top: 50, right: 80, bottom: 100, left: 60 }}
          xScale={{
            type: 'time',
            format: '%d-%m-%Y',
            precision: 'day',
          }}
          xFormat="time:%d-%b-%Y"
          yScale={{ type: 'linear' }}
          colors={['#51247A']}
          axisTop={null}
          axisRight={null}
          enableArea
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 90,
            legend: labels.x,
            legendOffset: 80,
            legendPosition: 'middle',
            format: '%d-%m-%Y',
          }}
          axisLeft={{
            format: yFormat,
            tickSize: 4,
            tickPadding: 5,
            tickRotation: 0,
            legend: labels.y,
            legendOffset: -50,
            legendPosition: 'middle',
          }}
          pointSize={1}
          useMesh
        />
      </div>
    </section>
  )
}
